(() => {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const initHomeCommerce = (root = document) => {
    root.querySelectorAll("[data-home-commerce]").forEach((section) => {
      if (section.dataset.v42Ready === "true") return;
      section.dataset.v42Ready = "true";
      const buttons = [...section.querySelectorAll("[data-home-filter]")];
      const cards = [...section.querySelectorAll("[data-home-product]")];
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const filter = button.dataset.homeFilter;
          buttons.forEach((item) => item.classList.toggle("is-active", item === button));
          const mutate = () => cards.forEach((card, index) => {
              const visible = filter === "all" || card.dataset.homeProduct === filter;
              card.hidden = !visible;
              if (visible && !reducedMotion && !window.DorimmMotion?.enabled) {
                card.animate(
                  [
                    { opacity: 0, transform: "translateY(20px)" },
                    { opacity: 1, transform: "translateY(0)" }
                  ],
                  { duration: 420, delay: index * 45, easing: "cubic-bezier(.2,.8,.2,1)" }
                );
              }
            });
          if (window.DorimmMotion?.enabled) window.DorimmMotion.flip(cards, mutate, { duration: .58 });
          else mutate();
        });
      });
    });
  };

  const initCardLight = (root = document) => {
    if (!window.matchMedia("(hover:hover) and (pointer:fine)").matches) return;
    root.querySelectorAll(".home-product__visual, .shop-path").forEach((card) => {
      if (card.dataset.lightReady === "true") return;
      card.dataset.lightReady = "true";
      card.addEventListener("pointermove", (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty("--light-x", `${event.clientX - rect.left}px`);
        card.style.setProperty("--light-y", `${event.clientY - rect.top}px`);
      });
    });
  };

  const initNavigation = () => {
    const shop = document.querySelector("[data-nav-shop]");
    const mobile = document.querySelector("[data-mobile-menu]");
    const language = document.querySelector("[data-language-menu]");
    document.addEventListener("pointerdown", (event) => {
      if (shop?.open && !shop.contains(event.target)) shop.removeAttribute("open");
      if (language?.open && !language.contains(event.target)) language.removeAttribute("open");
    });
    document.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      shop?.removeAttribute("open");
      if (mobile?.open) mobile.removeAttribute("open");
      if (language?.open) {
        language.removeAttribute("open");
        language.querySelector("summary")?.focus();
      }
    });
    mobile?.addEventListener("toggle", () => document.body.classList.toggle("mobile-nav-open", mobile.open));
    mobile?.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => mobile.removeAttribute("open")));
  };

  const initHeroState = () => {
    const hero = document.querySelector("[data-hero]");
    if (!hero) return;
    const update = () => {
      const amount = Math.min(1, window.scrollY / Math.max(1, hero.offsetHeight));
      hero.style.setProperty("--hero-scroll", amount.toFixed(3));
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
  };

  const init = (root = document) => {
    initHomeCommerce(root);
    initCardLight(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      init();
      initNavigation();
      initHeroState();
    }, { once: true });
  } else {
    init();
    initNavigation();
    initHeroState();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
